import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgVolumeLevel1 = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.832 5.24839L12.8336 17.7512C12.8336 18.7813 11.5486 19.3655 10.6677 18.7463L5.63677 15.1412H3.1767C2.55252 15.1412 2.00167 14.6612 2.00167 14.0428L2 8.9585C2 8.37515 2.51335 7.8593 3.17503 7.8593H5.6351L10.6661 4.25336C11.5469 3.63501 12.832 4.21836 12.832 5.24839ZM15.2411 8.74832C15.9828 9.38501 16.4328 10.3709 16.4328 11.5009C16.4328 12.6293 15.9561 13.6151 15.2145 14.2526C14.9219 14.5127 14.4719 14.4552 14.2344 14.1368L14.1819 14.0793C13.9436 13.7893 13.9969 13.326 14.2869 13.0943C14.7369 12.7468 15.0019 12.1676 15.0019 11.5009C15.0019 10.8917 14.7369 10.3417 14.3403 9.96502C14.0219 9.67502 13.9694 9.21084 14.2344 8.86333C14.4719 8.54415 14.9236 8.48665 15.2411 8.74832Z", fill: props.fill }));
});
export default SvgVolumeLevel1;
